<script setup>
import { PaginationRoot } from "reka-ui";
import { cn } from "@/shared/lib/utils";

const props = defineProps({
  total: { type: Number, default: 0 },
  itemsPerPage: { type: Number, default: 10 },
  siblingCount: { type: Number, default: 1 },
  defaultPage: { type: Number, default: 1 },
  page: { type: Number, default: undefined },
  showEdges: { type: Boolean, default: true },
  size: { type: String, default: "sm" },
  disabled: { type: Boolean, default: false },
  class: { type: [String, Object, Array], default: undefined },
});

const emit = defineEmits(["update:page"]);
</script>

<template>
  <PaginationRoot
    v-slot="slotProps"
    data-slot="pagination"
    :total="total"
    :items-per-page="itemsPerPage"
    :sibling-count="siblingCount"
    :default-page="defaultPage"
    :page="page"
    :size="size"
    :show-edges="showEdges"
    :class="
      cn(
        'h-6 mx-auto flex w-full justify-center',
        props.disabled && 'pointer-events-none opacity-50',
        props.class
      )
    "
    @update:page="emit('update:page', $event)"
  >
    <slot v-bind="slotProps" />
  </PaginationRoot>
</template>
